import { Typography } from "@mui/material";
import Popover from "@mui/material/Popover";
import React, { useState } from "react";
import { IconButtonClose, useClasses } from "./SimplePopover.styles";
import { CloseIconWrapper } from "../../../site/components/SearchBarSitesMachines/SearchBarSitesMachines.styles";
import { AppIconsClose } from "../../../site/components/AppIcons";
import { StyleguideSavioColors } from "../../../site/configuration/themeSettings";

type SimplePopoverType = {
  anchorElement: any;
  setAnchorElement: any;
  message: string | JSX.Element[] | null;
  setMessage?:
    | React.Dispatch<React.SetStateAction<string | JSX.Element[] | null>>
    | React.Dispatch<React.SetStateAction<string | null>>;
  showBelow?: boolean;
  showToLeft?: boolean;
  showCloseButton?: boolean;
};

export default function SimplePopover(props: SimplePopoverType) {
  const handleClose = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    props.setAnchorElement(null);

    if (props.setMessage !== undefined) props.setMessage(null);
  };

  const open = Boolean(props.anchorElement);
  const id = open ? "simple-popover" : undefined;
  const classes = useClasses();
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    props.anchorElement
  );

  return (
    <Popover
      id={id}
      open={open}
      anchorEl={props.anchorElement}
      onClose={handleClose}
      onClick={handleClose}
      anchorOrigin={{
        vertical: props.showToLeft
          ? "center"
          : props.showBelow
          ? "bottom"
          : "top",
        horizontal: props.showToLeft ? "right" : "center",
      }}
      transformOrigin={{
        vertical: props.showToLeft
          ? "center"
          : props.showBelow
          ? "top"
          : "bottom",
        horizontal: props.showToLeft ? "left" : "center",
      }}
      style={{ zIndex: 1000000, marginTop: props.showBelow ? "3px" : "" }}
      sx={classes.root}
      className="AppHeader-app-bar information"
      disableRestoreFocus={true}
    >
      {props.showCloseButton ? (
        <div
          style={{
            position: "absolute",
            right: 3,
            top: -1,
            zIndex: 10001,
          }}
          onClick={handleClose}
        >
          <IconButtonClose sx={{color: StyleguideSavioColors.blue}} onClick={handleClose}>
            <AppIconsClose />
          </IconButtonClose>

          
        </div>
      ) : (
        ""
      )}

      <Typography variant="body2">{props.message}</Typography>
    </Popover>
  );
}
